import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { moduleGuard } from './core/guards/module.guard';
import { LayoutComponent } from './core/layout/layout.component';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then(
            (m) => m.DASHBOARD_ROUTES,
          ),
      },
      {
        path: 'requirements',
        canActivate: [moduleGuard],
        data: { module: 'requirements' },
        loadChildren: () =>
          import('./features/requirements/requirements.routes').then(
            (m) => m.REQUIREMENTS_ROUTES,
          ),
      },
      {
        path: 'area-requirements',
        canActivate: [moduleGuard],
        data: { module: 'area-requirements' },
        loadChildren: () =>
          import('./features/area-requirements/area-requirements.routes').then(
            (m) => m.AREA_REQUIREMENTS_ROUTES,
          ),
      },
      {
        path: 'visits',
        canActivate: [moduleGuard],
        data: { module: 'visits' },
        loadChildren: () =>
          import('./features/visits/visits.routes').then(
            (m) => m.VISITS_ROUTES,
          ),
      },
      {
        path: 'purchase-orders',
        canActivate: [moduleGuard],
        data: { module: 'purchase-orders' },
        loadChildren: () =>
          import('./features/purchase-orders/purchase-orders.routes').then(
            (m) => m.PURCHASE_ORDERS_ROUTES,
          ),
      },
      {
        path: 'area-purchase-orders',
        canActivate: [moduleGuard],
        data: { module: 'area-purchase-orders' },
        loadChildren: () =>
          import('./features/area-purchase-orders/area-purchase-orders.routes').then(
            (m) => m.AREA_PURCHASE_ORDERS_ROUTES,
          ),
      },
      {
        path: 'suppliers',
        canActivate: [moduleGuard],
        data: { module: 'suppliers' },
        loadChildren: () =>
          import('./features/suppliers/suppliers.routes').then(
            (m) => m.SUPPLIERS_ROUTES,
          ),
      },
      {
        path: 'material-requirements',
        canActivate: [moduleGuard],
        data: { module: 'material-requirements' },
        loadChildren: () =>
          import('./features/material-requirements/material-requirements.routes').then(
            (m) => m.MATERIAL_REQUIREMENTS_ROUTES,
          ),
      },
      {
        path: 'distributions',
        canActivate: [moduleGuard],
        data: { module: 'distributions' },
        loadChildren: () =>
          import('./features/distributions/distributions.routes').then(
            (m) => m.DISTRIBUTIONS_ROUTES,
          ),
      },
      {
        path: 'cost-centers',
        canActivate: [moduleGuard],
        data: { module: 'cost-centers' },
        loadChildren: () =>
          import('./features/cost-centers/cost-centers.routes').then(
            (m) => m.COST_CENTERS_ROUTES,
          ),
      },
      {
        path: 'budgets',
        canActivate: [moduleGuard],
        data: { module: 'budgets' },
        loadChildren: () =>
          import('./features/budgets/budgets.routes').then(
            (m) => m.BUDGETS_ROUTES,
          ),
      },
      {
        path: 'users',
        canActivate: [moduleGuard],
        data: { module: 'users' },
        loadChildren: () =>
          import('./features/users/users.routes').then((m) => m.USERS_ROUTES),
      },
      {
        path: 'sync-users',
        canActivate: [moduleGuard],
        data: { module: 'sync-users' },
        loadChildren: () =>
          import('./features/sync-users/sync-users.routes').then(
            (m) => m.SYNC_USERS_ROUTES,
          ),
      },
      {
        path: 'sync-agencies',
        canActivate: [moduleGuard],
        data: { module: 'sync-agencies' },
        loadChildren: () =>
          import('./features/sync-agencies/sync-agencies.routes').then(
            (m) => m.SYNC_AGENCIES_ROUTES,
          ),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./features/profile/profile.routes').then(
            (m) => m.PROFILE_ROUTES,
          ),
      },
      {
        path: 'role-modules',
        canActivate: [moduleGuard],
        data: { module: 'role-modules' },
        loadChildren: () =>
          import('./features/role-modules/role-modules.routes').then(
            (m) => m.ROLE_MODULES_ROUTES,
          ),
      },
      {
        path: 'cripto-money',
        canActivate: [moduleGuard],
        data: { module: ['crypto', 'crypto-dashboard', 'crypto-operations', 'crypto-customers', 'crypto-exchange-rates', 'crypto-cash-drawer', 'crypto-wallets', 'crypto-currencies', 'crypto-billing', 'crypto-config', 'crypto-reports'] },
        loadChildren: () => import('./features/dashboard-cripto/dashboard-cripto.routes').then(m => m.DASHBOARD_CRIPTO_ROUTES),
      },
      {
        path: 'system-catalogs',
        canActivate: [moduleGuard],
        data: { module: 'system-catalogs' },
        loadChildren: () =>
          import('./features/system-catalogs/system-catalogs.routes').then(
            (m) => m.SYSTEM_CATALOGS_ROUTES,
          ),
      },
      {
        path: 'dashboard-clientes',
        canActivate: [moduleGuard],
        data: { module: 'dashboard-clientes' },
        loadChildren: () =>
          import('./features/dashboard-clientes/dashboard-clientes.routes').then(
            (m) => m.DASHBOARD_CLIENTES_ROUTES,
          ),
      },
      {
        path: 'warehouses',
        canActivate: [moduleGuard],
        data: { module: 'warehouses' },
        loadChildren: () =>
          import('./features/regular-customer/warehouses/warehouses.routes').then(
            (m) => m.WAREHOUSES_ROUTES,
          ),
      },
      {
        path: 'reward-categories',
        canActivate: [moduleGuard],
        data: { module: 'reward-categories' },
        loadChildren: () =>
          import('./features/regular-customer/reward-categories/reward-categories.routes').then(
            (m) => m.REWARD_CATEGORIES_ROUTES,
          ),
      },
      {
        path: 'rewards',
        canActivate: [moduleGuard],
        data: { module: 'rewards' },
        loadChildren: () =>
          import('./features/regular-customer/rewards/rewards.routes').then(
            (m) => m.REWARDS_ROUTES,
          ),
      },
      {
        path: 'my-stock',
        canActivate: [moduleGuard],
        data: { module: 'my-stock' },
        loadChildren: () =>
          import('./features/regular-customer/warehouse-rewards/warehouse-rewards.routes').then(
            (m) => m.WAREHOUSE_REWARDS_ROUTES,
          ),
      },
      {
        path: 'agencies-stock',
        canActivate: [moduleGuard],
        data: { module: 'rewards' },
        loadChildren: () =>
          import('./features/regular-customer/agencies-stock/agencies-stock.routes').then(
            (m) => m.AGENCIES_STOCK_ROUTES,
          ),
      },
      {
        path: 'customers',
        canActivate: [moduleGuard],
        data: { module: 'customers' },
        loadChildren: () =>
          import('./features/regular-customer/customers/customers.routes').then(
            (m) => m.CUSTOMERS_ROUTES,
          ),
      },
      {
        path: 'redeems',
        canActivate: [moduleGuard],
        data: { module: 'redeems' },
        loadChildren: () =>
          import('./features/regular-customer/redeems/redeems.routes').then(
            (m) => m.REDEEMS_ROUTES,
          ),
      },
      {
        path: 'dashboard-sorteo',
        canActivate: [moduleGuard],
        data: { module: 'dashboard-sorteo' },
        loadChildren: () =>
          import('./features/dashboard-sorteo/dashboard-sorteo.routes').then(
            (m) => m.DASHBOARD_SORTEO_ROUTES,
          ),
      },
      {
        path: 'maintenance',
        canActivate: [moduleGuard],
        data: { module: ['maintenance-equipment', 'maintenance-maintenances', 'maintenance-alerts', 'maintenance-costs', 'maintenance-types'] },
        loadChildren: () => import('./features/maintenance/maintenance.routes').then(m => m.MAINTENANCE_ROUTES),
      },
      {
        path: 'dashboard-intra',
        canActivate: [moduleGuard],
        data: { module: 'dashboard-intra' },
        loadChildren: () =>
          import('./features/dashboard-intra/dashboard-intra.routes').then(
            (m) => m.DASHBOARD_INTRA_ROUTES,
          ),
      },
      {
        path: 'metrics',
        canActivate: [moduleGuard],
        data: { module: ['metrics-dashboard', 'metrics-agencies', 'metrics-operations', 'metrics-western-union', 'metrics-clients', 'metrics-operators', 'metrics-cambistas', 'metrics-cf', 'metrics-alertas-tc', 'metrics-cross-sell', 'metrics-mapa-calor', 'metrics-resultados'] },
        loadChildren: () => import('./features/metrics/metrics.routes').then(m => m.METRICS_ROUTES),
      },
      {
        path: 'rrhh',
        canActivate: [moduleGuard],
        data: { module: ['rrhh-attendance', 'rrhh-employees', 'rrhh-shifts'] },
        loadChildren: () => import('./features/rrhh/rrhh.routes').then(m => m.RRHH_ROUTES),
      },
      {
        path: 'api-keys',
        canActivate: [moduleGuard],
        data: { module: 'api-keys' },
        loadChildren: () =>
          import('./features/api-keys/api-keys.routes').then(
            (m) => m.API_KEYS_ROUTES,
          ),
      },
      {
        path: 'informacion',
        canActivate: [moduleGuard],
        data: { module: 'informacion' },
        loadChildren: () =>
          import('./features/informacion/informacion.routes').then(
            (m) => m.INFORMACION_ROUTES,
          ),
      },
      {
        path: 'conciliaciones',
        canActivate: [moduleGuard],
        data: { module: ['conciliaciones-dashboard', 'conciliaciones-uploads', 'conciliaciones-transactions', 'conciliaciones-assignments', 'conciliaciones-accounts', 'conciliaciones-reports', 'conciliaciones-catalogs'] },
        loadChildren: () => import('./features/conciliaciones/conciliaciones.routes').then(m => m.CONCILIACIONES_ROUTES),
      },
      {
        path: 'cumplimiento',
        canActivate: [moduleGuard],
        data: { module: ['cumplimiento-cambistas'] },
        loadChildren: () => import('./features/cumplimiento/cumplimiento.routes').then(m => m.CUMPLIMIENTO_ROUTES),
      },
      {
        path: 'monnet',
        canActivate: [moduleGuard],
        data: { module: ['monnet-create', 'monnet-history'] },
        loadChildren: () => import('./features/monnet/monnet.routes').then(m => m.MONNET_ROUTES),
      },
      {
        path: 'boleteo',
        canActivate: [moduleGuard],
        data: { module: ['boleteo-create', 'boleteo-history'] },
        loadChildren: () => import('./features/boleteo/boleteo.routes').then(m => m.BOLETEO_ROUTES),
      },
      {
        path: 'projects',
        canActivate: [moduleGuard],
        data: { module: 'projects' },
        loadChildren: () => import('./features/projects/projects.routes').then(m => m.PROJECTS_ROUTES),
      },
    ],
  },
  {
    path: 'payout',
    loadComponent: () =>
      import('./features/monnet/pages/payout-form/payout-form.component').then(
        (m) => m.PayoutFormComponent,
      ),
  },
  {
    path: 'track/:trackingCode',
    loadComponent: () =>
      import('./features/distributions/public/track-distribution.component').then(
        (m) => m.TrackDistributionComponent,
      ),
  },
  { path: '**', redirectTo: 'dashboard' },
];
